import { render, staticRenderFns } from "./AddressInfo.vue?vue&type=template&id=e853f2c8&scoped=true&"
import script from "./AddressInfo.vue?vue&type=script&lang=js&"
export * from "./AddressInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e853f2c8",
  null
  
)

export default component.exports